import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import style from "../../assets/css/components/Form/Form.module.css";
import {
  UpdateStatusInitialState,
  UpdateStatusValidationSchema,
} from "../../utils/match";
import Button from "../Button/Button";
import InputSelect from "../Input/InputSelect";

import { socket } from "../../config/socket";
const MySwal = withReactContent(Swal);

function FormStatus({ idMatch, typeMatch }) {
  const options = [
    { value: "previa", label: "Previa" },
    { value: "pt", label: "1er. Tiempo" },
    { value: "mt", label: "Descanso" },
    { value: "st", label: "2do. Tiempo" },
    { value: "de", label: "Desempate" },
    { value: "fin", label: "Finalizado" },
  ];

  const handleSubmit = async (values) => {
    const { status } = values;

    console.log(typeMatch, status);

    socket.emit("statusMatch", { idMatch, typeMatch, status }, (match) => {
      MySwal.fire("cambio el estatus del partido");
    });

    const objIndex = options.findIndex((obj) => obj.value === status);
    const title = options[objIndex].label;

    socket.emit("addStory", { idMatch, title, type: 0 }, (story) => {
      MySwal.fire("story agregado");
      console.log(story);
    });
  };

  return (
    <Formik
      initialValues={UpdateStatusInitialState}
      validationSchema={UpdateStatusValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => (
        <Form className={classNames(style.form, style.formLive)}>
          <div className={classNames(style.formColumn, style.twoColumn)}>
            <InputSelect
              error={touched.status && errors.status}
              name="status"
              title="Estatus del partido"
              options={options}
              onChange={(selectedOption) => {
                handleChange("status")(selectedOption.value);
              }}
            />
          </div>
          <Button text="Guardar" />
        </Form>
      )}
    </Formik>
  );
}

export default FormStatus;
